module.exports = __webpack_public_path__ + "static/konzultace.8d34b3fe.jpg";